import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'app',
        component: () => import(/* webpackChunkName: "about" */ '../views/App.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '',
        name: 'frontpage',
        component: () => import('@/views/frontpage/Layout.vue'),
        children: [
            {
                path: 'login',
                name: 'login',
                props: {
                    title: 'Welcome',
                    subtitle: 'Enter your credentials to login',
                },
                component: () => import('../views/frontpage/login/Login.vue'),
            },
        ],
    },

    {
        path: '/signout',
        name: 'signout',
        component: () => import('@/components/auth/Signout.vue'),
        meta: { requiresAuth: true },
    },
];

const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes,
});

router.beforeEach(async (to, from, next) => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

    if (!requiresAuth) {
        if (await store.dispatch('Auth/auth')) {
            next({ name: 'app' });
        } else {
            next();
        }
    }

    if (requiresAuth) {
        if (await store.dispatch('Auth/auth')) {
            next();
        } else {
            store.dispatch('resetAll');
            window.vm.$snackbar('You have been automatically logged out because your session has expired. Please log back in.', 'error');
            next({ name: 'login' });
        }
    }
});

export default router;
